import React from "react";
import { BannerPanel } from "./bannerPanel/view";
import { BannerItem } from "./bannerItem/view";
import { Panel } from "./panel/view";
import { Html } from "./html/view";
import { TestimonialPanel } from "./testimonialPanel/view";
import { TestimonialItem } from "./testimonialItem/view";
import { ImagePanel } from "./imagePanel/view";
import { PageTiles } from "./pageTiles/view";
import { SingleBanner } from "./singleBanner/view";
import { ContactForm } from "./contactForm/view";
import { YoutubeBannerPanel } from "./youtubeBannerPanel/view";
import { Code } from "./code/view";
import { BlogPosts } from "./blogPosts/view";
import { BlogPostTitle } from "./blogPostTitle/view";
import { VideoHolder } from "./videoHolder/view";
import { VideoItem } from "./videoItem/view";
import { MultiColumnPanel } from "./multiColumnPanel/view";
import { ExpandableHtml } from "./expandableHtml/view";
import { ExpandablePanel } from "../../components/expandablePanel/view";

import { Carousel } from "./carousel/view";
import { CarouselItem } from "./carouselItem/view";
import { PrintShare } from "./printShare/view";

import { KsjbPageMenuBar } from "../../site/ksjbPage/ksjbPageMenuBar/view";
import { KsjbPageCarousel } from "../../site/ksjbPage/KsjbPageCarousel/view";
import { QuizPanel } from "../../site/ksjbPage/QuizPanel/view";

import { VideoEmbed } from "../../components/videoEmbed/view";
import { CookingCompanion } from "../../site/gourmetPro/sections/cookingCompanion";
import { InfoPanel2 } from "../../site/gourmetPro/sections/infoPanel2";
import { SlidingRecipeTiles } from "../../site/gourmetPro/sections/slidingRecipeTiles";
import { DifferenceInfoPanel } from "../../site/gourmetPro/sections/differenceInfoPanel";
import { RecipeRelProducts } from "../../components/recipeRelProducts/view";

export function Item(props) {
  const item = props.item;
  //const subItems = item.items || [];
  const cmsOption = props.cmsOption || {};
  //console.log('item', item, subItems, cmsOption);
  let itemElt = <></>;
  if (item.itemTypeCode === "Panel") {
    itemElt = <Panel item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "Html") {
    itemElt = <Html item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "BannerPanel") {
    itemElt = <BannerPanel item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "BannerItem") {
    itemElt = <BannerItem item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "TestimonialPanel") {
    itemElt = <TestimonialPanel item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "TestimonialItem") {
    itemElt = <TestimonialItem item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "ImagePanel") {
    itemElt = <ImagePanel item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "PageTiles") {
    itemElt = <PageTiles item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "SingleBanner") {
    itemElt = <SingleBanner item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "ContactForm") {
    itemElt = <ContactForm item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "YoutubeBannerPanel") {
    itemElt = <YoutubeBannerPanel item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "Code") {
    itemElt = <Code item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "Blog-Posts") {
    itemElt = <BlogPosts item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "Blog-PostTitle") {
    itemElt = <BlogPostTitle item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "MultiColumnPanel") {
    itemElt = <MultiColumnPanel item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "ExpandableHtml") {
    itemElt = <ExpandableHtml item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "VideoHolder") {
    itemElt = <VideoHolder item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "VideoItem") {
    itemElt = <VideoItem item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "Carousel") {
    itemElt = <Carousel item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "CarouselItem") {
    itemElt = <CarouselItem item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "PrintShare") {
    itemElt = <PrintShare item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "KsjbPageMenuBar") {
    itemElt = <KsjbPageMenuBar item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "KsjbPageCarousel") {
    itemElt = <KsjbPageCarousel item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "QuizPanel") {
    itemElt = <QuizPanel item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "VideoEmbed") {
    itemElt = <VideoEmbed item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "GourmetProCookiCom") {
    itemElt = <CookingCompanion item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "GourmetProInfoPanel2") {
    itemElt = <InfoPanel2 item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "GourmetProRecipe") {
    itemElt = <SlidingRecipeTiles item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "DifferenceInfoPanel") {
    itemElt = <DifferenceInfoPanel item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "RecipeRelProducts") {
    itemElt = <RecipeRelProducts item={item} cmsOption={cmsOption} />;
  } else if (item.itemTypeCode === "ExpandablePanel") {
    itemElt = <ExpandablePanel item={item} cmsOption={cmsOption} />;
  } else {
    itemElt = <div>{item.itemTypeCode}</div>;
  }

  // const subItemsElts = subItems.map((subItem, index) =>
  //   <Item item={subItem} key={subItem.itemId} cmsOption={cmsOption}></Item>
  // );
  return (
    <>
      {itemElt}
      {/* {subItemsElts} */}
    </>
  );
}
